import { render, staticRenderFns } from "./overseas-phone.vue?vue&type=template&id=7ea6284d&scoped=true"
import script from "./overseas-phone.vue?vue&type=script&lang=js"
export * from "./overseas-phone.vue?vue&type=script&lang=js"
import style0 from "./overseas-phone.vue?vue&type=style&index=0&id=7ea6284d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea6284d",
  null
  
)

export default component.exports